<template>
  <div class="sub-form-video sub-columns">
    <BaseInput name="width" validate="required|integer|min_value:1" suffix="px" class="sub-col" v-model="form.width" label="Width value" hint="Player width in pixels"/>
    <BaseInput name="height" validate="required|integer|min_value:1" suffix="px" class="sub-col" v-model="form.height" label="Height value" hint="Player height in pixels"/>
    <BaseSwitcher
      v-model="form.autoplay"
      class="sub-col"
      trueLabel="ON"
      falseLabel="OFF"
      label="Autoplay"
      hint="Autoplay video"
      fillSpace
    ></BaseSwitcher>
    <BaseSwitcher
      v-model="form.allowFullScreen"
      class="sub-col"
      trueLabel="YES"
      falseLabel="NO"
      label="Allow full screen"
      hint="Allow full screen for video"
      fillSpace
    ></BaseSwitcher>
  </div>
</template>

<script>
  import subformMixin from '@/mixins/sub-form.mixin'

  export default {
    mixins: [ subformMixin ],
    data () {
      return {
        form: {
          width: 480,
          height: 270,
          autoplay: true,
          allowFullScreen: true,
        }
      }
    }
  }
</script>

<style lang="scss">
  @import './sub-forms.scss';
  .sub-form-video {

    .base-input .wrapper__suffix {
      padding-right: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/forms/sub-forms/SubFormVideo.vue